import ActionTypes from './types';
import store from '../store/configureStore';

export const setPusherSocketId = (socketId) => {
  return (dispatch) => {
    dispatch({
      type: ActionTypes.SET_PUSHER_SOCKET_ID,
      socketId
    });
  };
};


// WEBPACK FOOTER //
// ./src/actions/pusher.js